import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuItem } from 'src/app/models/menu-item.model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuItemComponent implements OnInit, OnDestroy {
  @Input() menuItem: MenuItem;
  expanded: boolean;
  private subscription: Subscription;

  constructor(public router: Router) {}

  ngOnInit(): void {
    this.updateExpandedState();
    if (this.menuItem?.children?.length) {
      this.subscription = this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => this.updateExpandedState());
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateExpandedState(): void {
    if (this.menuItem?.children?.length) {
      const currentPath = (this.router.url.split('?')[0] || '/').replace(/^\//, '') || 'main';
      this.expanded = this.menuItem.children.some((child) =>
        this.itemOrDescendantMatchesRoute(child, currentPath)
      );
    }
  }

  /** Expande el padre si la ruta actual coincide con un hijo o nieto. */
  private itemOrDescendantMatchesRoute(item: MenuItem, currentPath: string): boolean {
    if (item.route && (currentPath === item.route || currentPath.startsWith(item.route + '/'))) {
      return true;
    }
    return item.children?.some((c) => this.itemOrDescendantMatchesRoute(c, currentPath)) ?? false;
  }

  onMenuSelected(menuItem: MenuItem): void {
    if (!menuItem.children || !menuItem.children.length) {
      if (menuItem.route) {
        void this.router.navigateByUrl('/' + menuItem.route);
      }
    } else {
      this.expanded = !this.expanded;
    }
  }

}
